const KEY = "wallace-tv:bearer";
const USER_KEY = "wallace-tv:user";

export interface StoredUser {
  id: string;
  username: string;
  display_name: string | null;
  is_admin: boolean;
}

export function getBearer(): string | null {
  return localStorage.getItem(KEY);
}

export function setBearer(token: string): void {
  localStorage.setItem(KEY, token);
}

export function clearBearer(): void {
  localStorage.removeItem(KEY);
  localStorage.removeItem(USER_KEY);
}

export function getCachedUser(): StoredUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try { return JSON.parse(raw) as StoredUser; } catch { return null; }
}

export function setCachedUser(u: StoredUser | null): void {
  if (u) localStorage.setItem(USER_KEY, JSON.stringify(u));
  else localStorage.removeItem(USER_KEY);
}
